export const LAUDOS_MEDICOS_LIMPAR_MENSAGEM = "LAUDOS_MEDICOS_LIMPAR_MENSAGEM";
export const LAUDOS_MEDICOS_INICIO_SOLICITACAO = "LAUDOS_MEDICOS_INICIO_SOLICITACAO";
export const LAUDOS_MEDICOS_SOLICITACAO_SUCESSO = "LAUDOS_MEDICOS_SOLICITACAO_SUCESSO";
export const LAUDOS_MEDICOS_SOLICITACAO_ERRO = "LAUDOS_MEDICOS_SOLICITACAO_ERRO";
export const LAUDOS_MEDICOS_DOWNLOAD_INICIO = "LAUDOS_MEDICOS_DOWNLOAD_INICIO";
export const LAUDOS_MEDICOS_DOWNLOAD = "LAUDOS_MEDICOS_DOWNLOAD";
export const LAUDOS_MEDICOS_DOWNLOAD_SUCESSO = "LAUDOS_MEDICOS_DOWNLOAD_SUCESSO";
export const LAUDOS_MEDICOS_DOWNLOAD_ERRO = "LAUDOS_MEDICOS_DOWNLOAD_ERRO";
export const LAUDOS_MEDICOS_INICIAR_SOLICITAR = "LAUDOS_MEDICOS_INICIAR_SOLICITAR";
export const LAUDOS_MEDICOS_SOLICITAR_SUCESSO = "LAUDOS_MEDICOS_SOLICITAR_SUCESSO";
export const LAUDOS_MEDICOS_SOLICITAR_ERRO = "LAUDOS_MEDICOS_SOLICITAR_ERRO";
export const AVALIACAO_SOCIAL_DOWNLOAD_INICIO = "AVALIACAO_SOCIAL_DOWNLOAD_INICIO";
export const AVALIACAO_SOCIAL_DOWNLOAD_SUCESSO = "AVALIACAO_SOCIAL_DOWNLOAD_SUCESSO";
